import type { FunctionComponent, MouseEventHandler } from 'react';

import type { StringSubstitutions } from '@trello/legacy-i18n';
import { forNamespace } from '@trello/legacy-i18n';
import { Button } from '@trello/nachos/button';
import type { PopoverTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import styles from './PopoverConfirm.less';

export interface PopoverConfirmProps {
  confirmKey: string;
  confirmCallback: MouseEventHandler;
  confirmSubstitutions?: StringSubstitutions;
  isDanger?: boolean;
  isLoading?: boolean;
}

export const PopoverConfirm: FunctionComponent<PopoverConfirmProps> = ({
  confirmKey,
  confirmCallback,
  confirmSubstitutions,
  isDanger,
  isLoading,
}) => {
  const format = forNamespace(['confirm', confirmKey]);

  return (
    <div
      className={styles.confirmContainer}
      data-testid={getTestId<PopoverTestIds>('popover-confirm')}
    >
      <p>{format('text', confirmSubstitutions)}</p>

      <Button
        appearance={isDanger ? 'danger' : 'primary'}
        autoFocus
        onClick={confirmCallback}
        size="fullwidth"
        testId={getTestId<PopoverTestIds>('popover-confirm-button')}
        isLoading={isLoading}
      >
        {format('confirm', confirmSubstitutions)}
      </Button>
    </div>
  );
};
